import { hash } from '@ember/helper';

import { t } from 'ember-intl';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';
import InfoBox from 'umg-ember-backend/components/ui/info-box';

export default class RecordDetailFormsMlpLiveEventFeedComponent extends Component {
  <template>
    {{#if @mlp.isV2}}
      <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
        <div class='o-layout'>
          <div class='o-layout__item u-1/1'>
            <form.fieldset @titleKey='elements' as |fieldset|>
              <fieldset.field @property='headline' />
              <fieldset.field
                @property='artist'
                @type='belongs-to'
                @on={{hash openNewRecord=false}}
              />
              <fieldset.field
                @property='channel'
                @type='belongs-to'
                @on={{hash openNewRecord=false}}
              />

              <fieldset.field @property='limit' @type='number' />
            </form.fieldset>
          </div>
        </div>
      </Form>
    {{else}}
      <InfoBox @type='warning'>
        {{t 'record_detail.forms.mlp_live_event_feed.only_for_mlp_v2'}}
      </InfoBox>
    {{/if}}
  </template>
}
